var _class, _descriptor, _descriptor2, _logEventsToConsole;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classPrivateMethodGet(s, a, r) { return _assertClassBrand(a, s), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Service, { inject as service } from '@ember/service';
import { CDP } from '@squareup/cdp';
import env from '@square/environment-utils/environment';
import { hasConsent, OneTrustConsent, onFirstConsent } from '@square/dashboard-utilities/utils/one-trust/one-trust-compliance';
import { getUrlFlag } from '@square/dashboard-utilities/utils/window';
import { getOwner } from '@ember/application';
import { underscore } from '@square/dashboard-utilities/utils/keys';
import Enum from '@square/dashboard-utilities/utils/enum';
import { DeviceProfileMessageStatuses } from '@square/dashboard-data/models/device-profiles-v2/device-profile-error';
export const DeviceType = Enum.create('DEVICE', 'DEVICE_CODE');
const DEVICE_PROFILE_V2_CDP_SOURCE = {
  production: 'd4db8b00-c066-42e0-b202-07a2735132be',
  staging: '0aea0a7b-6920-43bb-9ca4-462d2e8dd9cf',
  development: '0aea0a7b-6920-43bb-9ca4-462d2e8dd9cf'
};
export const DEVICE_PROFILE_V2_EVENTS = {
  DEVICE_PROFILE_CREATED: 'Device Profile Created',
  DEVICE_PROFILE_DUPLICATED: 'Device Profile Duplicated',
  DEVICE_PROFILE_DELETED: 'Device Profile Deleted',
  DEVICE_PROFILE_ASSIGNED_DEVICES_CHANGED: 'Device Profile Assigned Devices Changed',
  DEVICE_PROFILE_SERVER_ATTEMPTED_RESOLUTION: 'Device Profile Server Attempted Resolution',
  DEVICE_PROFILE_UNEXPECTED_STATUS: 'Device Profiles Fetch Unexpected Status',
  DEVICE_PROFILE_SETTING_CHANGED: 'Device Profile Setting Changed'
};
const UNEXPECTED_ERRORS_TO_TRACK = new Set([DeviceProfileMessageStatuses.MIGRATE_TO_V2, DeviceProfileMessageStatuses.NOT_MIGRATED, DeviceProfileMessageStatuses.INCOMPATIBLE_PROFILE_TYPE]);
let CdpEvents = (_class = (_logEventsToConsole = /*#__PURE__*/new WeakSet(), class CdpEvents extends Service {
  constructor(...args) {
    super(...args);
    _classPrivateMethodInitSpec(this, _logEventsToConsole);
    _defineProperty(this, "cdp", null);
    // Exposes instance of CDP library for this service's CDP source
    _initializerDefineProperty(this, "userInfo", _descriptor, this);
    _initializerDefineProperty(this, "datadogRumActions", _descriptor2, this);
    const owner = getOwner(this);
    onFirstConsent(owner, OneTrustConsent.TARGETING, () => {
      const apiKey = DEVICE_PROFILE_V2_CDP_SOURCE[env().name];
      const environment = env().name;
      this.cdp = new CDP({
        apiKey,
        environment,
        application: {
          name: 'app-dashboard'
        },
        // Registry app for DS event ownership attribution
        logEventsToConsole: _classPrivateMethodGet(this, _logEventsToConsole, _logEventsToConsole2).call(this),
        useSameOrigin: env().isProduction || env().isStaging
      });
    });
  }
  willDestroy() {
    this.cdp?.removeEventListeners();
  }
  track(eventName, properties = {}, context = {}) {
    if (hasConsent(OneTrustConsent.TARGETING) && eventName) {
      const updatedContext = {
        ...context,
        sessionId: this.userInfo.loggableSessionToken,
        eventSource: 'dashboard'
      };
      this.cdp.track(eventName, properties, {
        overrides: {
          context: updatedContext
        }
      });
    }
  }
  trackProfileCreated(profileCreatedData) {
    const payload = underscore(profileCreatedData);
    this.datadogRumActions.logAction(this.datadogRumActions.actionNames.XPOS_DEVICE_PROFILE_CREATED, payload);
    this.track(DEVICE_PROFILE_V2_EVENTS.DEVICE_PROFILE_CREATED, payload);
  }
  trackProfileDuplicated(profileDuplicatedData) {
    const payload = underscore(profileDuplicatedData);
    this.datadogRumActions.logAction(this.datadogRumActions.actionNames.XPOS_DEVICE_PROFILE_DUPLICATED, payload);
    this.track(DEVICE_PROFILE_V2_EVENTS.DEVICE_PROFILE_DUPLICATED, payload);
  }
  trackProfileDeleted(profileDeletedData) {
    const payload = underscore(profileDeletedData);
    this.datadogRumActions.logAction(this.datadogRumActions.actionNames.XPOS_DEVICE_PROFILE_DELETED, payload);
    this.track(DEVICE_PROFILE_V2_EVENTS.DEVICE_PROFILE_DELETED, payload);
  }
  trackProfileLinksChanged(profileLinksChangedData) {
    const payload = underscore(profileLinksChangedData);
    this.datadogRumActions.logAction(this.datadogRumActions.actionNames.XPOS_DEVICE_PROFILE_ASSIGNED_DEVICES_CHANGED, payload);
    this.track(DEVICE_PROFILE_V2_EVENTS.DEVICE_PROFILE_ASSIGNED_DEVICES_CHANGED, payload);
  }
  trackProfileSettingsChanged(profileSettingsChangedEventData) {
    const payload = {
      profile_id: profileSettingsChangedEventData.profileId,
      settings: JSON.stringify(underscore(profileSettingsChangedEventData.settings))
    };
    this.datadogRumActions.logAction(this.datadogRumActions.actionNames.XPOS_DEVICE_PROFILE_SETTING_CHANGED, payload);
    this.track(DEVICE_PROFILE_V2_EVENTS.DEVICE_PROFILE_SETTING_CHANGED, payload);
  }
  trackProfileResolutionAttempted() {
    this.datadogRumActions.logAction(this.datadogRumActions.actionNames.XPOS_DEVICE_PROFILE_SERVER_ATTEMPTED_RESOLUTION);
    this.track(DEVICE_PROFILE_V2_EVENTS.DEVICE_PROFILE_SERVER_ATTEMPTED_RESOLUTION, {});
  }
  maybeTrackProfileFetchUnexpectedStatus(profileFetchUnexpectedStatus) {
    if (UNEXPECTED_ERRORS_TO_TRACK.has(profileFetchUnexpectedStatus.status)) {
      const payload = underscore(profileFetchUnexpectedStatus);
      this.datadogRumActions.logAction(this.datadogRumActions.actionNames.XPOS_DEVICE_PROFILE_FETCH_UNEXPECTED_STATUS, payload);
      this.track(DEVICE_PROFILE_V2_EVENTS.DEVICE_PROFILE_UNEXPECTED_STATUS, payload);
    }
  }
}), _descriptor = _applyDecoratedDescriptor(_class.prototype, "userInfo", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "datadogRumActions", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
function _logEventsToConsole2() {
  if (getUrlFlag('logcdp', location)) {
    return 'on';
  }
  if (env().isTesting) {
    return 'off';
  }
  return 'default';
}
export { CdpEvents as default };